import { render, staticRenderFns } from "./RealTimeView.vue?vue&type=template&id=38f5f686&scoped=true"
import script from "./RealTimeView.vue?vue&type=script&lang=js"
export * from "./RealTimeView.vue?vue&type=script&lang=js"
import style0 from "./RealTimeView.vue?vue&type=style&index=0&id=38f5f686&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5f686",
  null
  
)

export default component.exports